export default __webpack_public_path__ + "static/b_radler_04-f415702c7de946c2eb4ee828c8921cd1.png";